export default __webpack_public_path__ + "static/media/github_menu.55e68326.svg";